import { createFromIconfontCN } from '@ant-design/icons'

export const IconFont = createFromIconfontCN({})
